import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';
import client from "./config/apolloClient";
import { ApolloProvider } from "@apollo/client";
import { registerServiceWorker } from './serviceWorkerRegistration';

const samplingRate = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1 ? parsed : fallback;
};

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
// Email approval URLs contain a one-time mailbox proof. Do not record this page.
if (sentryDsn && window.location.pathname !== '/VerifyIntakeEmail') {
    Sentry.init({
        dsn: sentryDsn,
        environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
        sendDefaultPii: false,
        enableLogs: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],
        tracesSampleRate: samplingRate(
            process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
            process.env.NODE_ENV === 'production' ? 0.1 : 0
        ),
        replaysSessionSampleRate: samplingRate(
            process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
            0
        ),
        replaysOnErrorSampleRate: samplingRate(
            process.env.REACT_APP_SENTRY_REPLAYS_ERROR_SAMPLE_RATE,
            0.5
        ),
        beforeSend: event => {
            if (event.user) {
                delete event.user.email;
                delete event.user.ip_address;
            }
            if (event.request?.headers) {
                delete event.request.headers.Authorization;
                delete event.request.headers.authorization;
                delete event.request.headers.Cookie;
                delete event.request.headers.cookie;
            }
            return event;
        },
    });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ApolloProvider client={client}>
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
